import { defineMessages } from 'react-intl-next';
export var cancelButtonMessages = defineMessages({
  cancelButtonText: {
    id: 'linkDataSource.configmodal.cancelButtonText',
    description: 'Button text to close the modal with no changes being made',
    defaultMessage: 'Cancel'
  }
});